<form [formGroup]="form" class="d-grid gap-2">
  <!-- Name Input -->
  <div>
    <label for="name" class="form-label">Name</label>
    <input type="text" id="name" formControlName="name" class="form-control"
      [class.is-invalid]="name.invalid && name.touched">
      @if (name.invalid) {
        <div class="invalid-feedback">Name is required.</div>
      }
    </div>

    <!-- File Input -->
    <div>
      <label for="e57File" class="form-label">File</label>
      <input type="file" accept=".e57" id="e57File" class="form-control" (change)="setFile($event.target.files[0])"
        [class.is-invalid]="file.invalid && file.touched">
        @if (file.errors?.invalidFileType) {
          <div class="invalid-feedback">File is invalid.</div>
        }
        @if (file.errors?.required) {
          <div class="invalid-feedback">File is required.</div>
        }
      </div>
    </form>